export const KINDEREDU_POPULAR_INSTITUTIONS_ACTION_FETCH = 'kinderedu_popular_institutions_action_fetch'

export const KINDEREDU_POPULAR_INSTITUTIONS_MUTATION_ADD_ITEM = 'kinderedu_popular_institutions_mutation_add_item'

export const KINDEREDU_POPULAR_INSTITUTIONS_GETTER_GET_LIST = 'kinderedu_popular_institutions_getter_get_list'
export const KINDEREDU_POPULAR_INSTITUTIONS_GETTER_GET_PAGE = 'kinderedu_popular_institutions_getter_get_page'
